import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_CALCULATOR_TYPES ({ state, commit }) {
    const { communityId } = state

    const query = `query calculatorApplicationTypes($input: GesuchsArtenInput!) {
      calculatorApplicationTypes(input: $input) {
        abkuerzung
        bezeichnung
        codeName
        id
      }
    }`

    const variables = {
      input: {
        gemeindeId: communityId
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async GET_CALCULATOR_FORM ({ state, commit }) {
    const { communityId, calculatorType } = state

    const query = `query calculatorFormByCode($input: GesucheFormInput!) {
      calculatorFormByCode(input: $input) {
        gemeindeId
        gesuchsartBezeichnung
        gesuchsartCode
        tabs{
          tag
          title
          formFields {
            title
            formGroups{
              sizes{
                ...sizeInfo
              }
              ...labelInfo
              fields{
                ...fieldInfo
                sizes{
                  ...sizeInfo
                }
                subFields{
                  ...labelInfo
                  fields{
                    ...fieldInfo
                    sizes{
                     ...sizeInfo
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    fragment labelInfo on FormGroupModel{
      label {
        for
        text
        sizes{
          ...sizeInfo
        }
      }
    }

    fragment fieldInfo on FieldModel{
      id
      appendedText
      defaultValue
      fieldType
      format
      helpText
      maxLength
      placeholder
      rule
    }

    fragment sizeInfo on GridModel{
      col
      colLg
      colMd
      colSm
      colXl
    }`

    const variables = {
      input: {
        gemeindeId: communityId,
        gesuchCode: calculatorType
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_CALCULATOR_FORM_FIELDS', data.data.calculatorFormByCode)
    }

    return data
  },
  async GET_ESTIMATE ({ state, commit }) {
    const { communityId, calculatorType } = state

    const query = `query calculatorEstimate($input: CalculatorEstimateInput!) {
      calculatorEstimate(input: $input) {
        result{
          foerderbetragBund
          foerderbetragGemeinde
          foerderbetragKanton
          gefoerdertDurchBund
          gefoerdertDurchGemeinde
          gefoerdertDurchKanton
          gemeindeId
          gemeindeName
          gesuchsartBezeichnung
          gesuchsartCode
          resultText
        }
      }
    }`

    const { formData } = state

    const gesuch = Object.keys(formData.gesuch).map(key => {
      const value = formData.gesuch[key]
      return { name: key, value: value }
    })

    const variables = {
      input: {
        gemeindeId: communityId,
        gesuchCode: calculatorType,
        gesuch
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_ESTIMATE', data.data.calculatorEstimate.result)
    }

    return data
  }
}
